module.exports = __webpack_public_path__ + "img/arrow.d9a47c30.svg";